import { Injectable } from '@angular/core';

import { MessageService } from '@app/core/message.service';
import { HttpService } from '@app/core/http/http.service';

import { UserTokenValidationResult } from '@app/shared/models/TokenModels';

import { Observable } from 'rxjs';

@Injectable()
export class TokenService {

  private apiroute: string = "/api/pass/emailval";
  constructor(private http: HttpService, private messageService: MessageService) { }

  public validateToken(token: string): Observable<UserTokenValidationResult> {

    this.messageService.clear();
    return this.http.get<UserTokenValidationResult>(this.apiroute + "?token=" + token);
  }
}
